import { render, staticRenderFns } from "./error-monitor-details-list.component.vue?vue&type=template&id=185cf96a&scoped=true&"
import script from "./error-monitor-details-list.component.vue?vue&type=script&lang=ts&"
export * from "./error-monitor-details-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./error-monitor-details-list.component.vue?vue&type=style&index=0&id=185cf96a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185cf96a",
  null
  
)

export default component.exports